import { api } from "@/api";
import { QueryConfig, QueryResult } from "@/shared/types/base";
import { CuentaCorriente } from "@/shared/types/cuenta-corriente";
import { sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function getCuenteCorriente(personaId: string): Promise<CuentaCorriente> {
    await sleep(1000);
    const response = await api.get("cuenta_corrientes/" + personaId);
    return response.data;
}

export function useGetCuentaCorrienteQuery(personaId: string, queryConfig: QueryConfig<CuentaCorriente> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCuenteCorriente(personaId),
        queryKey: ["cuenta_corrientes", personaId],
    })
}

export interface GetCuentaCorrienteQueryProps {
    personaId: string,
    queryConfig?: QueryConfig<CuentaCorriente>,
    children?: (queryResult: QueryResult<CuentaCorriente>) => ReactNode
}

export function GetCuentaCorrienteQuery({
    personaId,
    children,
    queryConfig
}: GetCuentaCorrienteQueryProps) {
    const queryResult = useGetCuentaCorrienteQuery(personaId, queryConfig);
    return children && children(queryResult);
}